var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","modo":"popup"}},[_c(_vm.componenteCarregado,_vm._b({tag:"component",staticClass:"janelaPopup"},'component',_vm.currentProperties,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }